<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Erreur !">
        <p>{{ message }}</p>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "BaseError",
  components: { BaseBlock },
  props: { message: String },
};
</script>
